import { useEffect, useState } from "react";

export function useAvailableColumns<T>(selectedColumns: T[], allColumns: T[], key: keyof T) {
  const [selected, setSelected] = useState<T[]>([]);
  const [availableColumns, setAvailableColumns] = useState<T[]>([]);

  useEffect(() => {
    setSelected(selectedColumns);

    const selectedInOrder = selectedColumns
      .map(selected => {
        return allColumns.find(col => col[key] === selected[key]);
      })
      .filter(Boolean) as T[];

    const selectedKeys = selectedColumns.map(col => col[key]);
    const unselected = allColumns.filter(col => !selectedKeys.includes(col[key]));

    setAvailableColumns([...selectedInOrder, ...unselected]);
  }, [selectedColumns, allColumns, key]);

  return { selected, availableColumns, setSelected };
}
